import { IMG_SRC, PAGE_SIZE, PAGE_SIZES } from '@/utils/constant';
import { gotoUrl } from '@/utils/util';
export default {
  data() {
    return {
      g_imgSrc: IMG_SRC,
      g_pageSizeDefault: PAGE_SIZE,
      g_pageSizesConfig: PAGE_SIZES,
    };
  },
  methods: {
    g_tourl(url, options) {
      gotoUrl(url, options);
    },
    g_breadcrumb(breadcrumb) {
      this.$store.commit('user/setBreadcrumb', breadcrumb);
    },
  },
};
